
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import ButtonVue from "@/lib/Button.vue";

import FinderInlineVue from "@/finder/FinderInline.vue";

import { Task } from "../../server/src/task/Task";
import { ITask } from "../../server/src/task/ITask";
import { TaskSvc } from "./TaskSvc";
import { ITaskParent } from "../../server/src/task/ITaskParent";
import { ITaskSearcher } from "../../server/src/task/ITaskSearcher";
import { DateString } from "@/DateString";
import ModalVue from "@/Modal.vue";
import { IGroup } from "@/groups/IGroup";
import {EmailFormatter } from "./EmailFormatter"
import { LblSvc } from "@/lbl/LblSvc";
import { OrderSvc } from "@/order/OrderSvc";

@Component({ name: 'TaskSendVue', components: { FinderInlineVue, ButtonVue, ModalVue } })
export default class TaskSendVue extends Vue {
  key = 0;

  task: ITask = new Task();

  @Prop(Object) parent!: ITaskParent;
  @Prop(String) re_id!: any;

  async mounted() {
   
    await this.refresh();
  }

  async refresh() {
    this.select_input()
    this.key++
  }

  convert_date(d: string) {
    if (!d) return "";
    const s = DateString.toISOString(d);
    return s;
  }

  async update_task() {
     if (!this.task.txt) {
      alert("Wpisz wiadomość!");
      return;
    }
    this.task.parent = this.parent;
    this.task.user = bus.get_user();
    this.task.parent.re_id = this.re_id;
    this.task.parent.lbl_url='/api/etykiety/'+this.task.parent.lbl_id


    const task = await new TaskSvc().fill_parent(this.task);
    

    if (task) this.task = task;
  }

  async send_teams(re_id:any) {

    await this.update_task()
    if (!this.task.txt) return;

/*   
    await bus.api("/api/teams/feedback", {
      teams: this.task.teams,
      text: this.task.txt,
      user_email: bus.get_user().data_email,
      lbl_url: window.location.href,
      klient_title: this.task.parent?.klient_title,
      prj_title: this.task.parent?.prj_title,
      lbl_title: this.task.parent?.lbl_title,
      order_title: this.task.parent?.order_title,
      op_title: this.task.parent?.op_title,
    });
*/
    await bus.api("/api/email/send", {task: this.task } )

    const fill_parent: number = 0;
    console.log("calling task save")
    const t: ITask | undefined = await new TaskSvc().save(this.task);
    if (t) this.task = t;
    this.task.txt = "";
    this.$emit('refresh')
    bus.fire('task_list_refresh',{})
    //await this.refresh();
  }

  async select_input() {
    if (this.$refs.task_text) {
      //this.$nextTick( () => (<any>this.$refs.task_text).focus() )
    }
  }

  ahref(url:string) {
    let html='<a href="'
    html +=url
    html+='">Test'
    html+="</a>"
    return html
  }

    async create_graflow_ids(body:string, crlf:string) {
      
      this.task.parent = this.parent
      const p = this.task.parent


      if (p) {

        const url = window.location.href
        
        const urlObj = new URL(url);
        const host = `${urlObj.protocol}//${urlObj.host}`;

        body+="GRAFLOW IDs. Nie usuwaj. Do not delete."+crlf

        if (p.prj_id) {
          const prj = await bus.call('/api/projekt/find_by_id', {_id: p.prj_id})
          if (prj) p.prj_title = prj.idn
          body+="Projekt "+host+"/app/projekty/"+p.prj_id+crlf
        }

        if (p.lbl_id) {
          const lbl = await new LblSvc().find_by_id(p.lbl_id)
          if (lbl) p.lbl_title = lbl.idn
          body+="Etykieta "+host+"/app/etykiety/"+p.lbl_id+crlf
        }

        if (p.order_id) {
          const order = await new OrderSvc().find_by_id(p.order_id)
          body+="Zlecenie "+host+"/app/zlecenia/"+p.order_id+crlf
        }
      } 
      return body;

    }
  
    async copy_graflow_ids_to_clipboard() {
      let body = await this.create_graflow_ids("", "\r\n")
      navigator.clipboard.writeText(body)
      alert("Skopiowano dane projektu do notatnika. Wejdź do maila i naciśnij Ctrl+V")
    }

    async redirect_create_email_OLD() {

      await this.update_task()

      if (!this.task) return;

      let addr ="https://outlook.office365.com/owa/?path=/mail/action/compose&"
      
      let body="Wpisz tu tekst maila...%0D%0A%0D%0A"
    
      body = await this.create_graflow_ids(body, "%0D%0A")

      let url:string =""
      url+="to=graflow@grafpol.com" // po przecinku lista
      url+="&subject="+this.task.txt
      url+="&body="+body
      url = url.replace(/ /g, '%20');

      url=addr+url
      console.log(url)

      //window.location.href=url
      window.open(url, '_blank', 'noreferrer');
  }



async redirect_create_email() {
    // Assuming this.update_task() and this.task are set properly
    await this.update_task();

    if (!this.task) return;

    let addr = "https://outlook.office365.com/owa/?path=/mail/action/compose&";

    let body = "";

    // Creating a clickable link in the body
    body = await this.create_graflow_ids(body,"\n")
    //body += `https://example.com \n https://example.com`;

    let url = "";
    url += "to=graflow@grafpol.com"; // You can add multiple recipients separated by comma
    url += "&subject=" + encodeURIComponent(this.task.txt); // Encoding subject to handle special characters
    url += "&body=" + encodeURIComponent(body); // Encoding body to handle special characters
    url = url.replace(/ /g, '%20');

    url = addr + url;
    console.log(url);

    window.open(url, '_blank', 'noreferrer');
}


  async fetch_emails() {
    const obj = await bus.api("/api/email/fetch_emails",{ lbl_id: this.parent.lbl_id})
    if (obj && obj.count) {
      alert("Zaczytano nowe maile:"+obj.count)
      await this.refresh()
    } else {
      alert("Brak nowych wiadomości")
    }


  }

}
